// Update this file manually each time you add a new article.
// Keep the most recent articles first.

const latestNews = [
  {
    date_fr: "28 Avril 2026",
    date_en: "28 April 2026",
    title_fr: "Accueil d'une délégation économique roumaine à Menzel Bourguiba",
    title_en: "Romanian economic delegation welcomed at Menzel Bourguiba",
    summary_fr:
      "Dans le cadre de la mission économique roumaine en Tunisie (Conect Bizerte), SACEM Industries a accueilli une délégation roumaine de haut niveau, ouvrant des perspectives de partenariat international.",
    summary_en:
      "As part of the Romanian economic mission to Tunisia (Conect Bizerte), SACEM Industries welcomed a high-level Romanian delegation, opening prospects for international partnership.",
  },
  {
    date_fr: "29 Avril 2026",
    date_en: "29 April 2026",
    title_fr: "Participation à la 7ᵉ édition du Salon de l'Emploi de l'Université Centrale",
    title_en: "Participation in the 7th Université Centrale Careers Fair",
    summary_fr:
      "SACEM Industries a participé au Salon de l'Emploi de l'Université Centrale (UTICA), occasion d'échanges avec étudiants et jeunes talents.",
    summary_en:
      "SACEM Industries participated in the Université Centrale Careers Fair at UTICA, engaging with students and young talent.",
  }
  
];

export default latestNews;
